import { generatePath } from 'react-router-dom'
import { GOOGLE_ADS_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { FileSearch1 } from 'blaze-ui/icons'
import { Pill } from 'components/Pill/Pill'
import Styles from '../NavMenu.module.scss'

interface Props {
  workspaceId: number
  onPress: () => void
}

const NavMenuGoogleAdsItem = ({ workspaceId, onPress }: Props) => {
  const to = generatePath(GOOGLE_ADS_PATH, { workspaceId })

  return (
    <NavMenuItem icon={FileSearch1} activeIcon={FileSearch1} to={to} onPress={onPress} label="Google Ads">
      <Pill className={Styles.betaPill} size="sm">
        Beta
      </Pill>
    </NavMenuItem>
  )
}

export { NavMenuGoogleAdsItem }
